<template>
    <div>
        <div v-for="data in optionShipping" class="text-center">
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label>ค่าเที่ยว{{data.name}}</label>
                </b-col>
                <b-col sm="5">
                    <input class="form-control"
                           :readonly="!canViewSuperAdmin"
                           v-model="data.fee"
                           type="text"/>
                </b-col>
            </b-row>
            <br>
        </div>
        <div class="text-center">
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label>ระยะทางไป-กลับ</label>
                </b-col>
                <b-col sm="5">
                    <input class="form-control"
                           v-model="set_km"
                           type="text"/>
                </b-col>
            </b-row>
            <br>
        </div>
        <div class="col text-center">
            <button @click="saveEditShipping"
                    type="button"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp&nbsp
            <button @click="cancelSubmit"
                    type="button"
                    class="btn btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import {canViewSuperAdmin} from "../../../util/Permissions";

    export default {
        name: "shipping-modal",
        data(){
          return{
              transport_fee:[],
              new_set_km:''
          }
        },
        created(){
            this.$store.dispatch('TransportType/setTransportTypes');
        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                transportType:state=>{
                    return state.TransportType.transportTypeList
                        .filter(data=>data.id != 4);
                },
                customerOther :state=>{
                    return state.Customer.customer_other ;
                },
                km : state=>{
                    return state.Customer.km_other;
                }
            }),
            optionShipping(){
                return this.customerOther[0].transport_price;
            },
            set_km : {
                get(){
                    return this.km;
                },
                set(value){
                    this.new_set_km = value;
                }
            }
        },
        methods:{
            saveEditShipping(){
                this.transport_fee = [];
                const shipping = this.optionShipping;
                if(shipping){
                    shipping.forEach(data=>{
                        const detail = {
                            customer_id : data.customer_other_id,
                            transport_id : data.transport_id ? data.transport_id : data.id,
                            name : data.name,
                            fee : parseInt(data.fee)
                        };
                        this.transport_fee.push(detail);
                    });
                    this.$store.dispatch('Customer/addShippingSubTransport',this.transport_fee);
                }
                let data = {
                    id : this.customerOther[0] ? this.customerOther[0].customer_id : '',
                    transport_customer : this.transport_fee,
                    km : this.new_set_km
                };
                this.$emit('submit',data);
            },
            cancelSubmit(){
                this.$emit('submit',0);
            }
        }
    }
</script>

<style scoped>

</style>
